import React from "react";

import { Provider } from "react-redux";
import { createEditorStore, EditorMode, HistoryMediator, ToolboxTabs } from "../../redux";
import { MetaNode } from "../../supportNodes";
import dragDropDecorator from "./dragDropDecorator";

export interface IEditorContainerProps {
    container: MetaNode;

    defaultSpacing: number;
}

class EditorContainerInner extends React.Component<IEditorContainerProps> {
    store = createEditorStore({
        mode: EditorMode.Edit,
        spacing: this.props.defaultSpacing,
        container: this.props.container,
        history: new HistoryMediator(),
        toolboxTab: ToolboxTabs.Items,
        isUploadingImage: false,
    });

    render() {
        return (
            <Provider store={this.store}>
                {this.props.children}
            </Provider>
        )
    }
}

export const EditorContainer = dragDropDecorator(EditorContainerInner)